import { Events } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BrComService } from '../../service/BrComService';
import { Contato } from '../../models/contato';
import { ContatoLocalProvider } from '../contato-local/contato-local';
import { EmpresaLocalProvider } from '../empresa-local/empresa-local'
import { HttpServidor } from '../shared/abstract/http-servidor';
import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../models/mensagem';
import { MensagemProvider } from '../mensagem/mensagem';

@Injectable()
export class ContatoProvider extends HttpServidor {

  constructor(http: HttpClient, 
    private mensagemProvider: MensagemProvider, 
    private contatoLocalProvider: ContatoLocalProvider, 
    private events: Events, 
    private brComService: BrComService,
    private empresaLocal: EmpresaLocalProvider) {
      super(http);
    }

  public getMensagensAntigasContato(idContato: number, idUltimaMensagem: number): Observable<Mensagem[]> {
    const form = new FormData();
    form.append('id_contato', String(idContato));
    form.append('id_envio_mais_antigo', String(idUltimaMensagem));
    return this.post('obtemMensagensAntigasContato', form);
  };

  public removerContato(idContato: number): Observable<void> {
    const idUsuario = this.empresaLocal.getEmpresa().IdUsuario;
    const idDevice = this.brComService.getIdDevice();
    const form = new FormData();
    form.append('id_contato', String(idContato));
    form.append('id_usuario', String(idUsuario));
    form.append('id_device', String(idDevice));
    return this.post('desativaContato', form);
  }

  public adicionarContato(idUsuario: number, idUsuarioContato: number): Observable<number> {
    const form = new FormData();
    form.append('id_usuario', String(idUsuario));
    form.append('id_usuario_contato', String(idUsuarioContato));
    return this.post('adicionaContato', form);
  }

  public listarContatosComNome(nome: string, idEmpresa: number): Observable<Contato[]> {
    const form = new FormData();
    form.append('nome_usuario', nome);
    form.append('id_empresa', String(idEmpresa));
    return this.post('listaContatosComNome', form);
  }

  public enviarMensagemSimples(idContato: number, idDevice: number, mensagem: string): Observable<number> {
    const form = new FormData();
    form.append('id_contato', String(idContato));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('mensagem', mensagem);
    return this.post('enviaMensagemSimplesContato', form);
  }

  public enviarMensagemImagem(idContato: number, idDevice: number, link: string): Observable<number> {
    const form = new FormData();
    form.append('id_contato', String(idContato));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('link', link);
    return this.post('enviaMensagemImagemContato', form);
  }

  public enviarMensagemArquivo(idContato: number, idDevice: number, arquivo: ArquivoMensagem): Observable<number> {
    const form = new FormData();
    form.append('id_contato', String(idContato));
    form.append('id_device', JSON.stringify(idDevice));
    form.append("arquivo", JSON.stringify(arquivo))
    return this.post('enviaMensagemArquivoContato', form);
  }

  public getContato(idContato: number): Observable<Contato> {
    const form = new FormData();
    form.append('id_contato', String(idContato));
    return this.post('obtemContato', form);
  }

  public notificarMensagensLidas(idContato: number, idDevice: number): Observable<void> {
    const form = new FormData();
    form.append('id_contato', JSON.stringify(idContato));
    form.append('id_device', JSON.stringify(idDevice));
    return this.post('registraMensagensContatoLidas', form);
  }

  public notificarMensagensRecebidas(idContato: number, idDevice: number): Observable<void> {
    const form = new FormData();
    form.append('id_contato', JSON.stringify(idContato));
    form.append('id_device', JSON.stringify(idDevice));
    return this.post('registraMensagensContatoRecebidas', form);
  }

  public enviarMensagensPendentes(): void {
    /*
    const mensagensComEnvioPendente = this.contatoLocalProvider.getMensagensComEnvioPendente();
    if (mensagensComEnvioPendente) {
      for (const mensagem of mensagensComEnvioPendente) {
        this.enviarMensagem(mensagem.idUsuarioOrigem, mensagem.idContato, mensagem.mensagem).subscribe(
          (idEnvio: number) => {
            this.contatoLocalProvider.atualizarMensagemEnviada(mensagem.idContato, mensagem.idEnvio, idEnvio);
          }
        )
      }
    }*/
  }

  public processarMensagemImagem(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemImagem(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMesagemArquivo(payload): void{
    const mensagem = this.mensagemProvider.criarMensagemArquivo(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemSimples(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemSimples(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public adicionarNovaMensagem(mensagem: Mensagem): void {
    const idUsuario = this.empresaLocal.getEmpresa().IdUsuario;
    const idDevice = this.brComService.getIdDevice();
    if (idUsuario === mensagem.idUsuarioOrigem) {
      this.adicionarNovaMensagemEnviadaDeOutroDevice(mensagem, idUsuario);
    } else {
      if (window.parent) {
        // envia mensagem para o sistema
        window.parent.postMessage({
          ok: true,
          code: "mensagem-contato",
          data: mensagem 
        }, "*");
      }
      const contato = this.contatoLocalProvider.getContato(mensagem.idContato);
      if (contato) {
        this.adicionarNovaMensagemContato(mensagem, contato, idDevice, idUsuario);
      } else {
        this.adicionarNovoContato(mensagem.idContato, idDevice, idUsuario);
      }
    }
  }

  public sincronizarContato(idContato: number): void {
    const contato = this.contatoLocalProvider.getContato(idContato);
    if (!contato) {
      const idDevice = this.brComService.getIdDevice();
      const idUsuario = this.empresaLocal.getEmpresa().IdUsuario;
      this.adicionarNovoContato(idContato, idDevice, idUsuario);
    }
  }

  public desativarContato(idContato: number): void {
    this.contatoLocalProvider.removerContato(idContato);
  }

  public processarMensagensRecebidas(idContato: number): void {
    this.contatoLocalProvider.marcarTodasMensagensRemetenteRecebida(idContato);
  }

  public processarMensagensLidas(idContato: number): void {
    this.contatoLocalProvider.marcarMensagensRemetenteLidas(idContato);
  }

  private adicionarNovaMensagemEnviadaDeOutroDevice(mensagem:any, idUsuario: number): void {
    mensagem.origem = OrigemMensagem.DIREITA;
    this.events.publish(`msg.contato.${mensagem.idContato}`, mensagem);
    this.contatoLocalProvider.adicionarNovaMensagem(mensagem.idContato, mensagem);
  }

  private adicionarNovaMensagemContato(mensagem:any, contato: Contato, idDevice: number, idUsuario: number): void {
    mensagem.origem = OrigemMensagem.ESQUERDA;
    this.events.publish(`msg.contato.${mensagem.idContato}`, mensagem);
    this.contatoLocalProvider.adicionarNovaMensagem(mensagem.idContato, mensagem);
    this.notificarMensagensRecebidas(contato.idContato, idDevice).subscribe(
      () => {
        this.contatoLocalProvider.marcarMensagemRecebida(contato.idContato, mensagem.idEnvio);
      }
    );
  }

  private adicionarNovoContato(idContato: number, idDevice: number, idUsuario: number): void {
    this.getContato(idContato).subscribe(
      (contato: Contato) => {
        this.contatoLocalProvider.adicionarContato(contato);
        this.notificarMensagensRecebidas(contato.idContato, idDevice).subscribe(
          () => {
            this.contatoLocalProvider.marcarTodasMensagensDestinatarioRecebida(contato.idContato);
          }
        );
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/providers/contato/contato.ts